import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import project from '@/api/project';
import user from '@/api/user';

const { getProductPrefix: gPP, getProductCategory: gPC, getProductRefType: gPRT, getProductStatus: gPS } = project();
const { getPrivilegeLevels: gPL } = user();

export const getProductPrefix = createAsyncThunk('content/setProductPrefix', async (params) => {
	const response = await gPP(params);
	return (
		response.data?.map((d) => {
			return { ...d, id: d.productprefixid, name: d.productprefixname };
		}) || []
	);
});

export const getProductCategory = createAsyncThunk('content/setProductCategory', async (params) => {
	const response = await gPC(params);
	return response.data || [];
});

export const getProductRefType = createAsyncThunk('content/setProductRefType', async (params) => {
	const response = await gPRT(params);
	return response.data || [];
});

export const getPrivilegeLevels = createAsyncThunk('content/setPrivilegeLevels', async (params) => {
	const response = await gPL(params);
	return response.data || [];
});

export const getProductStatus = createAsyncThunk('content/setProductStatus', async (params) => {
	const response = await gPS(params);
	return response.data || [];
});

const contentSlice = createSlice({
	name: 'content',
	initialState: {
		productPrefix: null,
		productCategory: null,
		refTypes: null,
		privilegeLevels: null,
		projectStatus: null,
		projectStatusD: null,
		projectStatusHome: null,
	},
	reducers: {
		resetFetchAPI(state) {
			const currState = state;
			currState.productPrefix = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(getProductPrefix.fulfilled, (state, action) => {
			const currState = state;
			currState.productPrefix = action.payload;
		});
		builder.addCase(getProductCategory.fulfilled, (state, action) => {
			const currState = state;
			currState.productCategory = action.payload;
		});
		builder.addCase(getProductRefType.fulfilled, (state, action) => {
			const currState = state;
			currState.refTypes = action.payload;
		});
		builder.addCase(getPrivilegeLevels.fulfilled, (state, action) => {
			const currState = state;
			const data = action.payload;
			data.unshift({ privilegelevelid: 99, privilegelevelname: 'Private' });
			currState.privilegeLevels = data.filter((d) => ![7, 8].includes(d.privilegelevelid));
		});
		builder.addCase(getProductStatus.fulfilled, (state, action) => {
			const currState = state;
			currState.projectStatus = action.payload?.filter((p) => p.id !== 5);
			currState.projectStatusD = action.payload?.filter((p) => [4, 7, 8].includes(p.id)).sort((a, b) => a.label < b.label ? 1 : a.label > b.label ? -1 : 0);
			currState.projectStatusHome = action.payload?.filter((p) => ![5, 8].includes(p.id)).sort((a, b) => a.label < b.label ? 1 : a.label > b.label ? -1 : 0);
		});
	},
});

export const contentActions = contentSlice.actions;
export default contentSlice;
